import fornecedoresApi from "@/app/services/fornecedores";

export default {
    namespaced: true,
    state: {
      fornecedor: {
        contas: [],
        chavespix: []
      },
      fornecedores: [],
      pagination: {},
      total_de_registros: 0,
      search: '',
      conta: {
        fornecedor_id: null,
        banco_id: null,
        agencia: '',
        numero_conta: '',
        titular: '',
        tipo_conta: 'corrente',
      },
      chavepix: {
        cliente_id: null,
        fornecedor_id: null,
        tipo: null,
        chave: null,
        titular: null,
        documento_titular: null,
      }
    },

    mutations: {
      listar(state, fornecedores) {
        state.fornecedores = fornecedores;
      },

      abrir(state, fornecedor) {
        state.fornecedor = fornecedor;
      },

      salvar(state, fornecedor) {
        state.fornecedores.push(fornecedor);
      },

      atualizar(state, fornecedor) {
        let index = state.fornecedores.findIndex(fornecedor_ => fornecedor_.id == fornecedor.id);
        if (index > -1) {
          state.fornecedores.splice(index, 1, fornecedor);
        }
      },

      excluir(state, id) {
        let index = state.fornecedores.findIndex(fornecedor => fornecedor.id == id);
        if (index > -1) {
          state.fornecedores.splice(index, 1);
        }
      },

      UNSET_FORNECEDOR(state) {
        state.fornecedor = {
          contas: [],
          chavespix: []
        };
      },

      SET_TOTAL(state, total) {
        state.total_de_registros = total;
      },

      SET_PAGE(state, page) {
        state.pagination.page = page;
      },

      SET_SEARCH(state, search) {
        state.search = search;
      },

      UPDATE_PAGINATION(state, options) {
        state.pagination = options;
      },

      SET_CONTA(state, conta) {
        state.conta = conta;
      },

      ADD_CONTA(state, conta) {
        state.fornecedor.contas.push(conta);
      },

      UPDATE_CONTA(state, conta) {
        let index = state.fornecedor.contas.findIndex(conta_ => conta_.id == conta.id);
        if (index > -1) {
          state.fornecedor.contas.splice(index, 1, conta);
        }
      },

      EXCLUIR_CONTA(state, conta_id) {
        let index = state.fornecedor.contas.findIndex(conta => conta.id == conta_id);
        if (index > -1) {
          state.fornecedor.contas.splice(index, 1);
        }
      },

      LIMPAR_CONTA(state) {
        state.conta = {
          fornecedor_id: null,
          banco_id: null,
          agencia: '',
          numero_conta: '',
          titular: '',
          tipo_conta: 'corrente',
        }
      },

      SET_CHAVEPIX(state, chavepix) {
        state.chavepix = chavepix;
      },

      ADD_CHAVEPIX(state, chavepix) {
        state.fornecedor.chavespix.push(chavepix);
      },

      UPDATE_CHAVEPIX(state, chavepix) {
        let index = state.fornecedor.chavespix.findIndex(chavepix_ => chavepix_.id == chavepix.id);
        if (index > -1) {
          state.fornecedor.chavespix.splice(index, 1, chavepix);
        }
      },

      EXCLUIR_CHAVEPIX(state, chavepix_id) {
        let index = state.fornecedor.chavespix.findIndex(chavepix => chavepix.id == chavepix_id);
        if (index > -1) {
          state.fornecedor.chavespix.splice(index, 1);
        }
      },

      LIMPAR_CHAVEPIX(state) {
        state.chavepix = {
          cliente_id: null,
          fornecedor_id: null,
          tipo: null,
          chave: null,
          titular: null,
          documento_titular: null,
        }
      }
    },

    actions: {
      async listar({commit, state}) {
        commit('LOADING_ON', null, {root: true});

        const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

        const parametros = {
          page, 
          itemsPerPage,
          sortBy: sortBy[0], 
          sortDesc: sortDesc[0]
        }

        if (state.search) {
          parametros.search = state.search;
          parametros.page = 1;
        }

        let response = await fornecedoresApi.listar(parametros);
        commit('listar', response.data);
        commit('SET_TOTAL', response.total);
        commit('LOADING_OFF', null, {root: true});
      },

      async abrir({commit}, id) {
        commit('LOADING_ON', null, {root: true});
        let fornecedor = await fornecedoresApi.abrir(id);
        commit('abrir', fornecedor);
        commit('LOADING_OFF', null, {root: true});
      },

      async salvar({commit}, fornecedor) {
        let novoFornecedor = await fornecedoresApi.salvar(fornecedor);
        commit('salvar', novoFornecedor);
      },

      async atualizar({commit}, fornecedor) {
        await fornecedoresApi.atualizar(fornecedor);
        commit('atualizar', fornecedor);
      },

      async excluir({commit}, id) {
        await fornecedoresApi.excluir(id);
        commit('excluir', id);
      },
      
      async salvarConta({commit}, conta) {
        let novaConta = await fornecedoresApi.salvarConta(conta);
        commit('ADD_CONTA', novaConta);
      },

      async atualizarConta({commit}, conta) {
        const conta_atualziada = await fornecedoresApi.atualizarConta(conta);
        commit('UPDATE_CONTA', conta_atualziada);
      },

      async exibirConta({commit}, conta_id) {
        let conta = await fornecedoresApi.exibirConta(conta_id);
        commit('SET_CONTA', conta);
      },

      async excluirConta({commit}, conta_id) {
        await fornecedoresApi.excluirConta(conta_id);
        commit('EXCLUIR_CONTA', conta_id);
      },

      async salvarChavePix({commit}, chavePix) {
        let novaChavePix = await fornecedoresApi.salvarChavePix(chavePix);
        commit('ADD_CHAVEPIX', novaChavePix);
      },

      async atualizarChavePix({commit}, chavePix) {
        const chavePix_atualziada = await fornecedoresApi.atualizarChavePix(chavePix);
        commit('UPDATE_CHAVEPIX', chavePix_atualziada);
      },

      async exibirChavePix({commit}, chavepix_id) {
        let chavePix = await fornecedoresApi.exibirChavePix(chavepix_id);
        commit('SET_CHAVEPIX', chavePix);
      },

      async excluirChavePix({commit}, chavepix_id) {
        await fornecedoresApi.excluirChavePix(chavepix_id);
        commit('EXCLUIR_CHAVEPIX', chavepix_id);
      },

    }
}
